$(function() {
  $('body').on('bless', function(e) {
    const $target = $(e.target)
    const $emptyStateContainter = $target.parents('[data-empty-check]')
    if ($emptyStateContainter.length) {
      const $target = $($emptyStateContainter.attr('data-empty-check'))
      const $emptyContainer = $emptyStateContainter.find(
        '.empty-state-container__empty-state',
      )
      const $fullContainer = $emptyStateContainter.find(
        '.empty-state-container__full-state',
      )
      if ($target.children().length == 0) {
        $emptyContainer.addClass('active')
        $fullContainer.removeClass('active')
      } else {
        $emptyContainer.removeClass('active')
        $fullContainer.addClass('active')
      }
    }
  })
})
